import { render, staticRenderFns } from "./MoleculeEditionBillingAcademyMigrationSaleInfo.vue?vue&type=template&id=b281a6ba"
import script from "./MoleculeEditionBillingAcademyMigrationSaleInfo.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingAcademyMigrationSaleInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports